<template>
  <div>
    <secondHeader />
    <div class="top">
      <sidebar />
      <div class="main">
        <div class="content-title">
          <h2>
            文字カウンター
          </h2>
        </div>
        <div>
          <ol class="count">
            <li>
              空白と改行を入れた文字数：
              <span class="yellow--text text--darken-3"
                >{{ textNormal }} 文字</span
              >
            </li>
            <li class="mt-2">
              空白と改行を除いた文字数：
              <span class="yellow--text text--darken-3"
                >{{ textNospace }} 文字</span
              >
            </li>
          </ol>
          <textarea v-model="inputText"></textarea>
        </div>
        <div class="ad-block">
          <div class="ad">
            <InFeedAdsense
                data-ad-layout-key="-fb+5w+4e-db+86"
                data-ad-client="ca-pub-9016794589237931"
                data-ad-slot="4898735474">
            </InFeedAdsense>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue"
import sidebar from "../components/sidebar.vue"

export default {
  name: "app",
  components:{
    secondHeader,
    sidebar,
  },
  data() {
    return {
      isProduction: process.env.NODE_ENV === "production",
      inputText: "",
    };
  },
  computed: {
    textNormal: function () {
      return this.inputText.length;
    },
    textNospace: function () {
      var spaceText = this.inputText;
      var noSpaceText = spaceText.replace(/\s+/g, "");
      return noSpaceText.length;
    },
  },
};
</script>
<style scoped >
@import url('https://fonts.googleapis.com/css2?family=Iceland&family=Open+Sans:wght@500&family=Shadows+Into+Light&display=swap');
.top{
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}
.main{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
  max-width: 767px;
  margin: 0 auto;
}
.content-title{
  text-align: center;
  padding-bottom: 12px;
}

h2{
  position: relative;
  display: inline-block;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

textarea {
  width:100%;
  min-height: 20em;
  max-width:100%;
}

ol.count{
  counter-reset:list;
  list-style-type:none;
  font: 14px/1.6 'arial narrow', sans-serif;
  padding:0;
}
ol.count li{
  position:relative;
  padding: 0 0 0 20px;
  margin: 7px 0 7px 0px;
  font-weight: bold;
  font-size:14px;
  line-height: 30px;
  border-bottom: dashed 1px #fff;
}
ol.count li:before{
  counter-increment: list;
  content: "";
  display: block;
  position: absolute;
  left: 0px;
  height: 0;
  width: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 7px solid #fff;
  top: 50%;
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.ad-block{
  padding: 12px 12px;
  display: block;
  width: 100%;
  margin-top:24px;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  display: block;
}
</style>